import React from 'react';
import { Box } from '@mui/material';
import './index.css';
import { RegisterIcon } from '../../assets/svg';

interface IRegisterLayout {
  children: React.ReactNode;
}

const RegisterLayout: React.FC<IRegisterLayout> = ({ children }) => {
  return (
    <Box className={'sign-up-box-full-height sign-up-box'}>
      <Box className={`signup-container-role-selected signup-container`}>
        <Box className={`sign-up-box--left-container`}>{children}</Box>
      </Box>
      <Box className={`register-img Image-wrapper`}>
        <RegisterIcon />
      </Box>
    </Box>
  );
};

export default RegisterLayout;
